import React, { useState, useEffect } from 'react';
import '../../App.css';
import '../faq-section/faqSection.css';

function FaqSection() {
  const [faqqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    async function fetchFaqs() {
      try {
        const response = await fetch('https://woolworths-classaction.staging3.dotwibe.com/api/api/faq');
        const json = await response.json();
        if (json.status && json.data) {
          setFaqs(json.data);
        }
      } catch (error) {
        console.error('Failed to fetch FAQs:', error);
      }
    }

    fetchFaqs();
  }, []);

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <h2>Frequently Asked Questions</h2>
        <p>Clear, factual answers to common questions about this class action.</p>
        <div className="faq-accord">
          {faqqs.map((faq, index) => (
            <div
              key={faq.id} // use unique id for key
              className={`faq-col1 ${activeIndex === index ? 'active' : ''}`}
            >
              <h3 onClick={() => handleClick(index)}>{faq.title}</h3>
              {activeIndex === index && (
                <div
                  className="content"
                  dangerouslySetInnerHTML={{ __html: faq.content }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
